module.exports = __webpack_public_path__ + "static/media/vishwahindisammelan.4c6bab94.jpeg";